import { fundingSDOptions, getThemeColors, getUSANumberFormat } from "app/utils/utils";
import IPPageNumber from "../IPPageNuber";
import { Chart } from "primereact/chart";
import { barGraphOptionsFunding } from "app/uicomponents/macrocomponents/PlansSummary/config";
import { getSessionStore } from "app/utils/sessionStore";
import HexagonImg from "../../images/hexagonImg.png";
import { getColorVariations } from "app/utils/colorUtils";
import { useContext } from "react";
import { ThemeContext } from "styled-components";

const SDIPFunding = ({
  graphData,
  pageNumber,
  isNewPage,
  tableData,
}: {
  graphData?: any;
  tableData?: any;
  pageNumber: string | number;
  isNewPage?: boolean;
}) => {
  const { branding } = getSessionStore("lookUpResponse");
  const { isDarkMode } = useContext(ThemeContext);
  const { primaryColor, ipTooltipColor, secondaryColor } = getThemeColors(branding);
  const limitedGraphData = graphData?.slice(0, 10);
  const datasets = [
    {
      backgroundColor: fundingSDOptions(primaryColor)[0].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.employeePremium),
      label: "Employee Premium",
    },
    {
      backgroundColor: fundingSDOptions(primaryColor)[1].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.employerPremium),
      label: "Employer Premium",
    },
    {
      backgroundColor: fundingSDOptions(primaryColor)[2].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.employeeInterestPayment),
      label: "Interest Payment",
    },
    {
      backgroundColor: fundingSDOptions(primaryColor)[3].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.adminFees),
      label: "Plan Fees",
    },
    {
      backgroundColor: fundingSDOptions(primaryColor)[4].indicatorColor,
      data: limitedGraphData?.map((item: any) => item?.planOriginationFees),
      label: "Origination Fees",
    },
  ];

  const subHeaders = [
    { label: "EMPLOYEE Premium" },
    { label: "EMPLOYEE Interest Payment" },
    { label: "EMPLOYEE Principal Payment" },
    { label: "EMPLOYER Premium" },
    { label: "Plan Fees" },
    { label: "Origination Fees" },
    { label: "Total Policy Premium" },
  ];

  const tableHeaders = [
    { label: "Year", rowSpan: 2 },
    { label: "Plan Year", rowSpan: 2 },
    { label: "Insured Age", rowSpan: 2 },
    { label: "Employee Out of Pocket Payments", colSpan: 3 },
    { label: "Employer Out of Pocket Payments", colSpan: 3 },
    { label: "Total Premium Paid to Insurance Company" },
  ];

  const getVariationColor = getColorVariations(secondaryColor, subHeaders.length);
  const variationColor = getVariationColor.reverse();

  const getVariationColorHeader = getColorVariations(secondaryColor, tableHeaders.length);
  const variationColorHeader = getVariationColorHeader.reverse();

  const mainContent = () => {
    if (isNewPage && tableData) {
      return (
        <div>
          <table className="w-full border-collapse">
            <thead className="text-white font-semibold">
              <tr>
                {tableHeaders?.map((item, index) => (
                  <th
                    key={item?.label}
                    {...(item?.colSpan && { colSpan: item?.colSpan })}
                    {...(item?.rowSpan && { rowSpan: item?.rowSpan })}
                    className="p-1 text-center pdf_table_border border-white"
                    style={{ backgroundColor: variationColorHeader[index], fontSize: "8px" }}
                  >
                    {item?.label}
                  </th>
                ))}
              </tr>
              <tr style={{ fontSize: "9px" }}>
                {subHeaders?.map((item, index) => (
                  <th
                    key={index}
                    className="p-1 text-center pdf_table_border border-white"
                    style={{ backgroundColor: variationColor[index] }}
                  >
                    {item?.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((policy: any, index: any) => (
                <tr
                  key={index}
                  style={{ backgroundColor: "#EEEEEE", color: "#000000", fontSize: "8px" }}
                >
                  <td className="p-1 text-center pdf_table_border border-white">
                    {policy?.planYear}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    {policy?.policyYear}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    {policy?.insuredAge}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.employeePremium, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.employeeInterestPayment, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.employeePrincipalPayment, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.employerPremium, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.annualAdminFees, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.planOriginationFees, false)}
                  </td>
                  <td className="p-1 text-center pdf_table_border border-white">
                    ${getUSANumberFormat(policy?.totalPolicyPremium, false)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <div>
        <div style={{ width: "503px" }}>
          <Chart
            type="bar"
            data={{
              labels: limitedGraphData?.map((item: any) => item?.planYear),
              datasets,
            }}
            options={barGraphOptionsFunding(false, ipTooltipColor, "Plan Year", "", "Plan Year")}
            key={`${isDarkMode}`}
            width="503px"
            height="450px"
          />
          <div className="flex flex-wrap justify-center gap-3">
            {datasets?.map(({ backgroundColor, label }, index) => (
              <div key={index} className="flex items-center">
                <span style={{ color: "#000000", fontSize: "16px" }}>{label}</span>
                <div
                  style={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor,
                    marginLeft: "2px",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col h-full relative min-h-screen">
      <div className="relative z-20 px-[2em] w-full max-w-[56em] mx-auto p-[1.75em]">
        {!isNewPage && (
          <h1 className="text-center text-2xl font-bold mb-5 conthrax-font interactive-proposal-text">
            Plan Funding
          </h1>
        )}
        {mainContent()}
      </div>

      <div className="absolute bottom-0 left-0 w-full">
        <div
          className="h-[350px] bg-cover bg-center"
          style={{
            backgroundImage: `url(${HexagonImg})`,
            backgroundSize: "cover",
          }}
        />
        <div className="px-[4em] w-full max-w-[56em] mx-auto p-[1.75em] pt-1">
          <IPPageNumber number={pageNumber} />
        </div>
      </div>
    </div>
  );
};

export default SDIPFunding;
